import React from 'react'
import Hero from '../hero/Hero'
import Testimony from '../testimonies/Testimony'

const Home = () => {
    return (
        <div>
            <Hero />
            <Testimony />
        </div>
    )
}

export default Home
